// Gestionnaire d'erreurs pour les erreurs bénignes
export const setupErrorHandler = () => {
  // Capturer les erreurs ResizeObserver qui sont généralement bénignes
  const originalError = console.error;
  console.error = (...args) => {
    if (
      args[0] && 
      typeof args[0] === 'string' && 
      args[0].includes('ResizeObserver loop completed with undelivered notifications')
    ) {
      // Ignorer cette erreur spécifique car elle est bénigne
      return;
    }
    // Laisser passer toutes les autres erreurs
    originalError.apply(console, args);
  };

  // Gestionnaire global pour les erreurs non capturées
  window.addEventListener('error', (event) => {
    if (event.error && event.error.message && 
        event.error.message.includes('ResizeObserver loop completed with undelivered notifications')) {
      event.preventDefault();
      return false;
    }
  });

  // Gestionnaire pour les erreurs de promesses non capturées
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && event.reason.message && 
        event.reason.message.includes('ResizeObserver loop completed with undelivered notifications')) {
      event.preventDefault();
      return false;
    }
  });
};
